import { useQuery } from '@tanstack/react-query'
import { fetchVerticalTableData } from 'services/verticalsTablesApi'
import { BaseEntityForTable } from 'utils/types'
import { MRT_SortingState } from 'material-react-table'
import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

interface UseVerticalEntitiesPaginatedQuery {
  verticalIndices: string
  currentQueryKey: string
  searchValue?: string
  searchColumn?: string
  sorting?: MRT_SortingState
  filters?: Filter[]
  vertical?: string
  pageSize?: number
  page: number
}

export const useVerticalEntitiesPaginatedQuery = <T extends BaseEntityForTable>({
  verticalIndices,
  currentQueryKey,
  searchValue,
  searchColumn,
  sorting,
  filters,
  vertical,
  pageSize = 10,
  page,
}: UseVerticalEntitiesPaginatedQuery) => {
  const from = (page - 1) * pageSize

  const { data, isFetching, isLoading, isError } = useQuery<T[]>({
    queryKey: [currentQueryKey, verticalIndices, searchValue, searchColumn, sorting, filters, vertical, pageSize, page],
    queryFn: () =>
      fetchVerticalTableData(verticalIndices, from, pageSize, searchValue, sorting, filters, vertical, searchColumn),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    verticalEntities: data || null,
    isFetching,
    isLoading,
    isError,
  }
}
